import { FC, useState } from "react";
import './Operation.scss';

export type OperationProps = {
  name: string,
};

const Operation: FC<OperationProps> = (props) => {

  const [open, setOpen] = useState<boolean>(false);

  return (
    <div className="op">
      <div className="op-bar" onClick={() => setOpen(!open) }>{ props.name } { open ? '-' : '+' }</div>
      { open && props.children }
    </div>
  );
}

export default Operation;
